import { render, staticRenderFns } from "./SGShardedClusterStatus.vue?vue&type=template&id=dfcbbb98&scoped=true"
import script from "./SGShardedClusterStatus.vue?vue&type=script&lang=js"
export * from "./SGShardedClusterStatus.vue?vue&type=script&lang=js"
import style0 from "./SGShardedClusterStatus.vue?vue&type=style&index=0&id=dfcbbb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcbbb98",
  null
  
)

export default component.exports